import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import EventCard from '../Events/EventCard';
import { useQuery } from "@tanstack/react-query";
import { getEventsFn } from "../APIServices/Services";
import Spinner from "../ui/Spinner";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { Typography } from "@mui/material";



export default function Events() {
  const { data, isError, error, isLoading } = useQuery(["events"], getEventsFn)

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Spinner />
        </Container>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            Oops, something went wrong
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {error.toString()}
          </Typography>
        </Container>
      </Box>
    );
  }

  if (data.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            No Events added yet!
          </Typography>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }} style={{ padding: 10 }}>
      <Stack spacing={4}>
        {data.results.map((event) => (
            <EventCard details={event} />
        ))}
      </Stack>
    </Box>
  );
}
